//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { NavigationItemState } from './Enums';

export class TeacherNavigationPreferencesDisplayItem extends ItemBase {
    ShowPackages: NavigationItemState = NavigationItemState.Show;
    ShowExpensesRevenue: NavigationItemState = NavigationItemState.Show;
    ShowDirectory: NavigationItemState = NavigationItemState.Show;
    ShowOnlineResources: NavigationItemState = NavigationItemState.Show;
    ShowBusinessReports: NavigationItemState = NavigationItemState.Show;
    ShowWebsite: NavigationItemState = NavigationItemState.Show;
    ShowHomeworkSubmission: NavigationItemState = NavigationItemState.Show;
    ShowRepertoire: NavigationItemState = NavigationItemState.Show;
    ShowLendingLibrary: NavigationItemState = NavigationItemState.Show;
    ShowNewsPosts: NavigationItemState = NavigationItemState.Show;
    ShowMileage: NavigationItemState = NavigationItemState.Show;

    constructor(initializer?: Partial<TeacherNavigationPreferencesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherNavigationPreferencesDisplayItem";
}
